export default "__VITE_ASSET__GWLfdKuF__"